import {Locale} from 'next-intl';
import {JSX} from 'react';
import Achievement from '../modules/Achievement';
import ArticleNote from '../modules/ArticleNote';
import BrandCategoryList from '../modules/BrandCategoryList';
import BrandList from '../modules/BrandList';
import ContactList from '../modules/ContactList';
import DragBtnList from '../modules/DragBtnList';
import FormBuilder from '../modules/FormBuilder';
import GalleryList from '../modules/GalleryList';
import GrowthStoryList from '../modules/GrowthStoryList';
import HtmlTab from '../modules/HtmlTab';
import ImageText from '../modules/ImageText';
import LatestNewsList from '../modules/LatestNewsList';
import LatestNewsSlider from '../modules/LatestNewsSlider';
import LatestSustainabilityStory from '../modules/LatestSustainabilityStory';
import MarketExpansion from '../modules/MarketExpansion';
import Menu185 from '../modules/Menu185';
import Milestones from '../modules/Milestones';
import MilestonesPage from '../modules/MilestonesPage';
import PostList from '../modules/PostList';
import PostShare from '../modules/PostShare';
import PrivacyCode from '../modules/PrivacyCode';
import Quote from '../modules/Quote';
import ReservationFormBuilder from '../modules/ReservationFormBuilder';
import Slider from '../modules/Slider';
import StaffStoryList from '../modules/StaffStoryList';
import StaffStorySlider from '../modules/StaffStorySlider';
import SustainabilityList from '../modules/SustainabilityList';
import Template from '../modules/Template';
import WatsonMagazineList from '../modules/WatsonMagazineList';
import WatsonTvList from '../modules/WatsonTvList';
import {genHash} from './utils';

type GetLayoutProps = {
  locale: Locale;
  moduleSlug: string;
  moduleName: string;
  moduleData: any;
  moduleOption: any;
  options: any;
};

export default function getLayout(props: GetLayoutProps): JSX.Element {
  const {locale, moduleSlug, moduleName, moduleData, moduleOption, options} =
    props;
  const hash = genHash();

  switch (moduleName) {
    case 'template':
      return <Template {...{moduleOption}} />;

    case 'slider':
      return <Slider {...{moduleOption}} />;

    case 'latest-sustainability-story-slider':
    case 'latest-sustainability-story':
      return <LatestSustainabilityStory {...{locale, moduleData}} />;

    case 'watsons-tv-list':
      return <WatsonTvList />;

    case 'latest-news-list':
      return <LatestNewsList />;

    case 'watson-magazine-list':
      return <WatsonMagazineList />;

    case 'sustainability-list':
      return <SustainabilityList sustainability={moduleSlug} />;

    case 'latest-news-slider':
      return <LatestNewsSlider {...{moduleData}} />;

    case 'milestone':
      return <Milestones {...{moduleData, moduleOption}} />;

    case 'milestones':
      return <MilestonesPage {...{moduleData, moduleOption}} />;

    case 'achievements':
      return <Achievement {...{moduleData, moduleOption}} />;

    case 'gallery':
    case 'gallery-list':
      return <GalleryList />;

    case 'post-share':
      const page = options?.page;
      return <PostShare title={page?.title || page?.name || ''} />;

    case 'post-list':
      return <PostList {...{moduleOption}} />;

    case 'staff-story-list':
      return <StaffStoryList />;

    case 'staff-story-slider':
      return <StaffStorySlider {...{moduleOption, moduleData}} />;

    case 'brand-cate-list':
      return <BrandCategoryList {...{moduleData, moduleOption}} />;

    case 'brand-list':
      return <BrandList {...{moduleData, moduleOption}} />;

    case 'contact':
      return <ContactList {...{moduleData, moduleOption}} />;

    case 'form':
      return (
        <FormBuilder
          page_slug={options?.page?.slug || moduleSlug}
          form_slug={moduleSlug}
          meta={{...moduleOption, hash}}
        />
      );

    case 'note':
      return <ArticleNote {...{moduleOption}} />;

    case 'quote':
      return <Quote {...{moduleOption}} />;

    case 'html-tab':
      return <HtmlTab {...{moduleSlug, moduleOption}} />;

    case 'growth-story-list':
      return <GrowthStoryList {...{moduleOption}} />;

    case 'image-text':
      return <ImageText {...{moduleOption}} />;

    case 'menu-185':
      return <Menu185 {...{moduleData}} />;

    case 'market-expansion':
      return <MarketExpansion {...{moduleData}} />;

    case 'reservation-form':
      return (
        <ReservationFormBuilder
          page_slug={options?.page?.slug || moduleSlug}
          form_slug={moduleSlug}
          meta={{...moduleOption, hash}}
        />
      );
    case 'privacy-code':
      return <PrivacyCode />;

    case 'drag-btn-list':
      return <DragBtnList {...{moduleOption}} />;

    default:
      return <></>;
  }
}
